module.exports = __webpack_public_path__ + "img/bee_charge_logo.a3d2343d.png";